import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

console.log('🔍 Environment variables check:', {
  VITE_SUPABASE_URL: supabaseUrl || 'MISSING',
  VITE_SUPABASE_ANON_KEY: supabaseAnonKey ? 'SET (length: ' + supabaseAnonKey.length + ')' : 'MISSING',
  NODE_ENV: import.meta.env.MODE,
  ALL_ENV_VARS: Object.keys(import.meta.env).filter(key => key.startsWith('VITE_'))
})

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = 'Missing Supabase environment variables'
  console.error('❌ ' + errorMsg + ':', {
    VITE_SUPABASE_URL: supabaseUrl ? 'Set' : 'Missing',
    VITE_SUPABASE_ANON_KEY: supabaseAnonKey ? 'Set' : 'Missing',
    HELP: 'Please check your .env file and ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set correctly.'
  })
  throw new Error(errorMsg + '. Please check your .env file and ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set correctly.')
}

console.log('✅ Supabase client configuration:', {
  url: supabaseUrl,
  hasAnonKey: !!supabaseAnonKey,
  urlLength: supabaseUrl.length,
  keyLength: supabaseAnonKey.length
})

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Test connection without problematic promise chaining
const testConnection = async () => {
  try {
    const result = await supabase.from('profiles').select('count').limit(1)
    if (result.error) {
      console.error('❌ Supabase connection test failed:', result.error)
    } else {
      console.log('✅ Supabase connection test successful')
    }
  } catch (error) {
    console.error('❌ Supabase connection test error:', error)
  }
}

testConnection()